import { IpAddressesState } from '@pages/security/store/states/ip-addresses.state';
import { MyPublicIpState } from '@pages/security/store/states/my-public-ip.state';
import { PasswordPolicyState } from '@pages/security/store/states/password-policy.state';

export const securityPageState = [IpAddressesState, MyPublicIpState, PasswordPolicyState];
